import React, { useState } from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import './../../assets/css/student/home/FaqSection.css';

function FaqSection() {
  const [activeKey, setActiveKey] = useState('0');

  const faqs = [
    {
      id: '0',
      question: 'How can I donate?',
      answer: 'You can donate securely online through our website or contact us for other options.'
    },
    {
      id: '1',
      question: 'How are funds utilized?',
      answer: 'All donations are used to provide books, uniforms, and cover fees for underprivileged students. We maintain complete transparency and provide regular updates.'
    },
    {
      id: '2',
      question: 'Can I volunteer internationally?',
      answer: 'Yes! We welcome volunteers from around the world. Contact our team to learn about volunteer opportunities and requirements.'
    }
  ];

  return (
    <section className="faq-section-wrapper">
      {/* Top Heading */}
      <Container>
        <div className="faq-top-header">
          <p className="faq-orange-label">Your questions answered</p>
          <h2 className="faq-main-title">
            Get informed now.<br />
            Answers to your common questions
          </h2>
        </div>
      </Container>

      {/* Images + FAQ Content */}
      <Container>
        <Row className="faq-main-content">
          {/* Left - Images Grid (2x2) */}
          <Col lg={5} md={12} className="faq-left-images">
            <div className="faq-images-grid-layout">
              <div className="faq-img-box faq-img-top-left">
                <img src="https://universidadeuropea.com/resources/media/images/ngo_800.width-640.jpg" alt="Donation support" />
              </div>
              <div className="faq-img-box faq-img-top-right">
                <img src="https://images.squarespace-cdn.com/content/v1/5abb72ffaa49a1b4940d782f/607ad1f4-33f9-423a-ae8e-adba3ccea97a/Donor+Pyramid_Feature.jpg" alt="Community help" />
              </div>
              <div className="faq-img-box faq-img-bottom-left">
                <img src="https://img.freepik.com/premium-photo/word-donations-is-spelled-out-wooden-blocks_384948-15015.jpg?semt=ais_hybrid&w=740&q=80" alt="Hands donation" />
              </div>
              <div className="faq-img-box faq-img-bottom-right">
                <img src="https://www.luminafoundation.org/wp-content/uploads/2025/01/students-banner.jpg" alt="Volunteers" />
              </div>
            </div>
          </Col>

          {/* Right - FAQ Accordion */}
          <Col lg={7} md={12} className="faq-right-accordion">
            <h3 className="faq-title">Frequently asked questions</h3>
            <p className="faq-subtitle">
              Can't find what you're looking for? Get in touch with our team and we will gladly help out.
            </p>

            <Accordion activeKey={activeKey} onSelect={setActiveKey} className="faq-custom-accordion">
              {faqs.map((faq, idx) => (
                <Accordion.Item eventKey={faq.id} key={faq.id} className="faq-accordion-item-custom">
                  <Accordion.Header className="faq-accordion-header-custom">
                    {idx + 1}. {faq.question}
                  </Accordion.Header>
                  <Accordion.Body className="faq-accordion-body-custom">
                    {faq.answer}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>

      {/* Decorative Curves */}
      <div className="faq-curve-decoration-1"></div>
      <div className="faq-curve-decoration-2"></div>
    </section>
  );
}

export default FaqSection;